import {safeBase64Url} from '../../_web/utils/url'
import {ImageProvider} from '../types/ImageProvider'

type FactoryConfigs = {
  secret: string
  url: string
}

/**
 * This image provider will use imgproxy to process images according to our necessities
 * Passing the configuration
 * @param config necessary configuration in order for the imgproxy service to work
 * @returns an image provider method of the type ImageProvider
 */
export const imageProviderImgProxyFactory =
  (config: FactoryConfigs): ImageProvider =>
  (url, size, {resizingType = 'fit', ...processingOptions} = {}) => {
    if (!url) return ''

    const [imageWidth, imageHeight] = size
    const requestedOptions = Object.entries(processingOptions).filter(
      ([, value]) => value !== undefined
    )
    const options = {
      rs: `${resizingType}:${imageWidth}:${imageHeight}:0:0`,
      dpr: 1,
      ...Object.fromEntries(requestedOptions)
    }

    const processingPath = Object.entries(options)
      .map(([option, value]) => `${option}:${value}/`)
      .join('')

    return `${config.url}${safeBase64Url(
      `${btoa(config.secret)}|/${processingPath}${safeBase64Url(url)}.webp`
    )}`
  }
